var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section-header',{attrs:{"text":"About"}}),_c('v-container',[_c('v-row',[_c('v-col',[_vm._v(" Strata Focus was born out of the need to manage the volume of data that comes with managing a portfolio of stratas. built with one goal: "),_c('strong',[_vm._v("make strata financial management simple.")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }